
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiApiDialog extends Serenity.EntityDialog<UtentiApiRow, any> {
        protected getFormKey() { return UtentiApiForm.formKey; }
        protected getIdProperty() { return UtentiApiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiApiRow.localTextPrefix; }
        protected getService() { return UtentiApiService.baseUrl; }
        protected getDeletePermission() { return UtentiApiRow.deletePermission; }
        protected getInsertPermission() { return UtentiApiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiApiRow.updatePermission; }

        protected form = new UtentiApiForm(this.idPrefix);

    }
}